/**
 * URL utility functions for parsing and extracting information from URLs.
 */

/**
 * Extracts the app name from a URL pathname following the pattern /app/{appname}/...
 *
 * @param {string} pathname - The pathname from window.location or useLocation
 * @returns {string|null} - The extracted app name or null if not found
 *
 * @example
 * extractAppNameFromPath('/app/dispatch/2025-07-21') // returns 'dispatch'
 * extractAppNameFromPath('/app/timekeeping/some-page') // returns 'timekeeping'
 * extractAppNameFromPath('/other/path') // returns null
 */
export function extractAppNameFromPath(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return null;
  }

  const pathSegments = pathname.split("/");

  if (pathSegments[3]) {
    return pathSegments[3];
  }
  return null;
}

/**
 * Extracts the domain from a URL pathname following the pattern /app/{domain}/...
 *
 * @param {string} pathname - The pathname from window.location or useLocation.
 * @returns {string|null} The extracted domain or null if not found.
 *
 * @example
 * extractDomainFromPath('/app/dispatch/2025-07-21') // returns 'dispatch'
 * extractDomainFromPath('/app/timekeeping/some-page') // returns 'timekeeping'
 * extractDomainFromPath('/other/path') // returns null
 */
export function extractDomainFromPath(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return null;
  }

  const pathSegments = pathname.split("/");

  if (pathSegments[2]) {
    return pathSegments[2];
  }
  return null;
}
